import { render, staticRenderFns } from "./productionTask.vue?vue&type=template&id=38ecd530"
import script from "./productionTask.vue?vue&type=script&lang=js"
export * from "./productionTask.vue?vue&type=script&lang=js"
import style0 from "./productionTask.vue?vue&type=style&index=0&id=38ecd530&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports